import React, {Component} from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import {Link} from 'react-router';
import classnames from 'classnames';

import {ButtonLink} from 'components/controls';
import styles from './AuthHeader.scss';

class LogOutDropdown extends Component {
    static propTypes = {
        role: PropTypes.object,
        onClose: PropTypes.func,
        onLogout: PropTypes.func,
        isVisible: PropTypes.bool
    };

    static defaultProps = {
        isVisible: false,
        role: {},
    };

    render() {
        const {onClose, isVisible, role} = this.props;
        const containerClass = classnames(styles.dropDownContainer, isVisible ? styles.visible : '');
        return (
            <div className={containerClass}>
                <div className={styles.arrowUp}>
                </div>
                {role.isDoctor() &&
                    <Link
                        to={'/availability'}
                        onClick={onClose}
                        className={styles.linkDropDown}
                    >
                        {loc('edit-availability-label')}
                    </Link>
                }
                <Link to={'/settings'} onClick={onClose} className={styles.linkDropDown}>{loc('settings')}</Link>
                <ButtonLink onClick={this.handleLogout} className={styles.linkDropDown} label={loc('logout-label')} />
            </div>
        );
    }

    handleClickOutside = (e) => {
        const {onClose} = this.props;
        onClose();
    };

    handleLogout = () => {
        this.props.onClose();
        this.props.onLogout();
    }

}

export default onClickOutside(LogOutDropdown);



// WEBPACK FOOTER //
// ./src/components/Auth/LogOutDropdown.js